module.exports={
    REACT_APP_BE_URL:'https://lounge-backend.onrender.com',
    REACT_APP_STRIPE_PUBLIC_KEY:'pk_test_51MgPNUSGJWduBmwsipwpGdodNDToVW3dynb2wJ1WodeBiNCTmOpTzuTD9350zWhEH4p4mRPCNnomI1b7uFCGJzt70016bD7AeD'

}  